import config from '@/config';
import { ILang } from './type';

const list: ILang['list'] = [
    {
        tagName: 'PoE IP Kameras & NVRs',
        link: `${config.store}/poe-ip-cameras/`
    },
    {
        tagName: 'Dual-Objektiv Kameras',
        link: `${config.store}/dual-lens-cameras/`
    },
    {
        tagName: 'Video-Türklingeln',
        link: `${config.store}/video-doorbells/`
    },
    {
        tagName: 'WLAN Kameras',
        link: `${config.store}/wifi-security-cameras/`
    },
    {
        tagName: 'Akkukameras',
        link: `${config.store}/battery-security-cameras/`
    },
    {
        tagName: 'Sicherheitskamerasysteme',
        link: `${config.store}/security-camera-systems/`
    },
    {
        tagName: 'KEEN (Trail-Kamera)',
        link: `${config.official}/product/keen-ranger-pt/`
    },
];

const title: ILang['title'] = 'Ihr smartes und sicheres Zuhause mit Reolink bilden';

export const de = {
    list,
    title
};
